module.exports = __webpack_public_path__ + "static/media/phone-usa.b6bda7e6.png";